import React from 'react';
import { connect } from 'react-redux';
import { fetchAdministrationMotifsResolution } from 'store/administration/administrationActions';

import { postMotifResolution } from 'store/administration/administrationActions';
import { deleteMotifResolution } from 'store/administration/administrationActions';

import AdministrationMotifsResolution from './AdministrationMotifsResolution';
import withLoader from 'components/Shared/withLoader';

const AdministrationMotifsResolutionWithLoader = withLoader(AdministrationMotifsResolution);

class AdministrationMotifsResolutionContainer extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            addMotifResolutionDialogOpen: false,
            deleteMotifResolutionDialogOpen: false,
            motifResolutionToDelete: null
        };
    }

    async componentDidMount() {
        await this.props.fetchAdministrationMotifsResolution({ avecNbActions: true });
    }


    handleOpenAddDialog = () => {
        this.setState({
            addMotifResolutionDialogOpen: true
        });
    };
    handleCloseAddDialog = () => {
        this.setState({
            addMotifResolutionDialogOpen: false
        });
    };

    addMotifResolution = async (motifResolution) => {
        await this.props.postMotifResolution(motifResolution);
    };
             
    

    handleOpenDeleteDialog = (motifResolutionId) => {        
        this.setState({
            deleteMotifResolutionDialogOpen: true,
            motifResolutionToDelete: this.props.motifsResolution.find(x => x.id === motifResolutionId)
        });
    };
    handleCloseDeleteDialog = () => {
        this.setState({
            deleteMotifResolutionDialogOpen: false,
            motifResolutionToDelete: null
        });
    };
    

    deleteMotifResolution = async (motifResolutionId) => {

        this.setState({
            deleteMotifResolutionDialogOpen: false
        });
        await this.props.deleteMotifResolution(motifResolutionId);
    };

    render() {
        const { isLoading, motifsResolution } = this.props;

        return (
            <AdministrationMotifsResolutionWithLoader
                isLoading={isLoading}
                motifsResolution={motifsResolution}

                addMotifResolutionDialogOpen={this.state.addMotifResolutionDialogOpen}
                addMotifResolution={this.addMotifResolution}
                onOpenAddDialog={this.handleOpenAddDialog}
                onCloseAddDialog={this.handleCloseAddDialog}


                deleteMotifResolutionDialogOpen={this.state.deleteMotifResolutionDialogOpen}
                deleteMotifResolution={this.deleteMotifResolution}
                onOpenDeleteDialog={this.handleOpenDeleteDialog}
                onCloseDeleteDialog={this.handleCloseDeleteDialog}
                motifResolutionToDelete={this.state.motifResolutionToDelete}
            />
        );
    }
}

const mapStateToProps = state => ({
    isLoading: state.administration.motifsResolution.isLoading,
    motifsResolution: state.administration.motifsResolution.items
});


const mapDispatchToProps = {
    fetchAdministrationMotifsResolution,
    postMotifResolution,
    deleteMotifResolution
};

export default connect(mapStateToProps, mapDispatchToProps)(AdministrationMotifsResolutionContainer);